<template>
    <div class="form login__form">
        <form v-on:submit.prevent="tryLogin">
            <div v-if="isPasswordReset" class="alert alert-success text-center mb-xl" role="alert">
                Passwort erfolgreich geändert.
            </div>

            <p class="text-center" v-if="errorMessage">
                <strong>{{ errorMessage }}</strong>
            </p>

            <div class="form__group">
                <label for="email">{{ __('login.username') }}</label>
                <input 
                    id="email" 
                    type="email" 
                    :class="{ 'is-invalid': errorFields.includes('username') }" 
                    name="email" 
                    v-model="username"
                    autocomplete="email"
                    spellcheck="false" 
                    required
                    autofocus />
            </div>

            <div class="form__group mb-sm">
                <label for="password">{{ __('login.password') }}</label>
                <input 
                    id="password" 
                    type="password" 
                    :class="{ 'form-control': true, 'is-invalid' : errorFields.includes('password') }" 
                    name="password"
                    v-model="password" 
                    autocomplete="current-password"
                    required />
            </div>

            <div class="lh-1">
                <a :href="`${env.PORTAL_URL}/password/reset`">{{ __('login.request_password') }}</a>
            </div>

            <div class="form__group login__form__buttons text-center">
                <button type="submit" class="btn btn-icon btn-primary">
                    {{ __('login.login') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ViewBase from './ViewBase';

export default {
    extends: ViewBase,
    props: {
        isPasswordReset: {
            type: Boolean
        },
        email: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            errorMessage: null,
            errorFields: [],
            username: this.email,
            password: '',
        }
    },
    methods: {
        async tryLogin() {
            this.app.isLoading = true;

            let formData = new FormData();

            formData.append('grant_type', 'password');
            formData.append('client_id', this.env.OAUTH_CLIENT_ID);
            formData.append('client_secret', this.env.OAUTH_CLIENT_SECRET);
            formData.append('scope', '*');
            formData.append('username', this.username);
            formData.append('password', this.password);

            try {
                const response = await fetch(this.env.PORTAL_URL + '/oauth/token', {
                    method: 'POST',
                    body: formData
                });
                const data = await response.json();

                if('user' in data && 'access_token' in data) {
                    // login successful
                    this.$store.commit('user/login', data);

                    await this.$store.dispatch('loadOptions');

                    this.app.isLoading = false;
                    this.$router.push('/');
                } else if('error' in data) {
                    throw data.error;
                } else {
                    throw 'Invalid Login Response';
                }
            } catch(error) {
                this.app.isLoading = false;
                this.errorMessage = this.__('login.errors.' + error, error);

                if(error == 'invalid_grant') {
                    this.errorFields = [ 'username', 'password' ];
                }
            }
        }
    }
}
</script>